import { Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';
import { MatDialogClose } from '@angular/material/dialog';

@Component({
  selector: 'app-network-check-offline-modal',
  imports: [MatButton, TranslatePipe, MatDialogClose],
  templateUrl: './network-check-offline-modal.component.html',
  styleUrl: './network-check-offline-modal.component.scss'
})
export class NetworkCheckOfflineModalComponent {}
